import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CTAButton, Text, NavBar, MenuToggle, BgVideo } from '../../../components/core';
import ScreenHalfContent from './ScreenHalfContent'
import Logo from '../../../components/core/Logo';
import Chapters from '../../Menus/Chapters/Chapters';
import Tour from '../../Tour';
import useMobile from '../../../other/Hooks/useMobile';
import Theme from '../../../Theme';
import { assetsPath } from '../../../other/constants';

type HalfScreenProps = {
  enter: boolean
  focusedScreen: '' | 'left' | 'right'
}

const ScreenLeftContainer = styled.div`
  ${({ focusedScreen }: HalfScreenProps) => {
    switch (focusedScreen) {
      case 'left':
        return `
          width: 100%;
          display: flex;
          align-items: center;
        `;
      case 'right':
        return `
          width: 0%;
        `;
      default:
        return `
          width: 50%;
        `;
    }
  }}

  height: 100%;
  position: absolute;
  top: 0;
  left: ${({ enter }: HalfScreenProps) => enter ? 0 : '-50%'};
  z-index: 2;
  transition: all 1s ease-in-out;
`;

const ScreenLeftContent = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .header-container {
    margin-bottom: 22px;
    width: 82%;
  }

  .white-line {
    width: 100%;
    border: 1px solid white;
    height: 1px;
    margin-bottom: 22px;
  }

  .button-container {
    width: 82%;
    display: flex;

    > *:nth-child(2) {
      margin-left: 18px;
    }

    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
      flex-direction: column;

      > *:nth-child(2) {
        margin-left: 0px;
        margin-top: 20px;
      }
    }
  }
`;

const MenuIconContainer = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 12;
  padding: 15px;
  cursor: pointer;
`;

type Props = {
  backToSplit: any
  enter: boolean
  focusedScreen: 'left' | 'right' | ''
  setFocusedScreen: React.Dispatch<React.SetStateAction<"" | "left" | "right">>
}

const ScreenLeft = ({ enter, focusedScreen, setFocusedScreen, backToSplit }: Props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [playTour, setPlayTour] = useState(false)
  const [timestamp, setTimestamp] = useState(0)
  const [remove, setRemove] = useState(false)

  const isMobile = useMobile()

  useEffect(() => {
    (async () => {
      if (enter && focusedScreen === 'right') await setTimeout(() => setRemove(true), 1000)
      else setRemove(false)
    })()

  }, [enter, focusedScreen])

  if (remove) return null

  const handleMenuClick = () => {
    setMenuOpen(prev => !prev);
  };

  const changeScreen = () => {
    setFocusedScreen('right');
  };
  const playVideo = (timestamp: number) => {
    setTimestamp(timestamp)
    setPlayTour(true)
    setMenuOpen(false)
  }



  return (
    <ScreenLeftContainer
      enter={enter}
      focusedScreen={focusedScreen}
      onClick={() => {
        if (isMobile && focusedScreen !== 'left') setFocusedScreen('left')
      }}
    >
      <BgVideo src={`${assetsPath}trailerv2.mp4`} darkOverlay={.3} />
      { focusedScreen === 'left' && <NavBar backToSplit={() => {
        setPlayTour(false)
        backToSplit()
      }} onClick={changeScreen} text='INTERACTIVE MAP' position={'right'} />}
      {
        focusedScreen === 'left' &&
        <MenuIconContainer onClick={handleMenuClick}>
          <MenuToggle open={menuOpen} />
        </MenuIconContainer>
      }
      {
        focusedScreen === 'left' && !playTour && <ScreenLeftContent>
          <a href='https://www.liuna.org/' target="_blank">
            <Logo position='left' />
          </a>
          <div className='header-container'>
            {
              isMobile
                ? <Text variant='Header1'>WELCOME TO LiUNA LOCAL 183 VIRTUAL 360 TOUR</Text>
                : <>
                  <Text variant='Header4'>WELCOME TO LiUNA LOCAL</Text>
                  <Text variant='Header4'>183 VIRTUAL 360 TOUR</Text>
                </>
            }

          </div>
          <div className='white-line'></div>
          <div className='button-container'>
            <CTAButton onClick={() => setPlayTour(true)} variant='solid'>PLAY FROM BEGINNING</CTAButton>
            <CTAButton onClick={() => setMenuOpen(true)} variant='transparent'>VIEW CHAPTERS</CTAButton>
          </div>
        </ScreenLeftContent>
      }
      {
        focusedScreen === 'left' && playTour && <Tour
          menuOpen={menuOpen}
          backToSplit={() => {
            setPlayTour(false);
            backToSplit();
          }}
          changeScreen={changeScreen}
          timestamp={timestamp}
          backToChapters={() => setPlayTour(false)}
        />
      }
      {focusedScreen === "" && !isMobile && <ScreenHalfContent
        key={`${enter}`}
        position='left'
        header={['TAKE A VIRTUAL', '360 TOUR']}
        body='The safety and comfort of our visitors are important to us. With our virtual tour, you don’t need to leave the house to see our facilities. Move at your own pace while enjoying a detailed 360 view of our training centre.'
      />
      }
      {
        menuOpen && <Chapters playVideo={playVideo} />
      }
    </ScreenLeftContainer>
  );
};

export default ScreenLeft;